import Vue from 'vue';

export default {
    namespaced: true,

    state: () => ({
        sections: [],
    }),

    getters: {
        validSections(state) {
            return state.sections.filter((section) => !!section.ref);
        }
    },

    actions: {
        setSections({ commit }, sections) {
            commit('setSections', sections);
        }
    },

    mutations: {
        setSections(state, sections) {
            state.sections = sections;
        }
    }
}